import { useState, useMemo, useEffect } from 'react';
import { useTextureLoader } from 'drei';
import { RepeatWrapping, Vector2 } from 'three';

function getFormatString(format) {
  switch (format) {
    case 64:
      return "-64px";

    case 128:
      return "-128px";

    case 256:
      return "-256px";

    case 512:
      return "-512px";

    default:
      return "";
  }
}

const MATCAP_ROOT = "https://rawcdn.githack.com/emmelleppi/matcaps/9b36ccaaf0a24881a39062d05566c9e92be4aa0d";
const DEFAULT_MATCAP = "0404E8_0404B5_0404CB_3333FC";
function useMatcapTexture(id = 0, format = 1024) {
  const [matcapList, setMatcapList] = useState({});
  const fileHash = useMemo(() => {
    if (typeof id === "string") {
      return id;
    } else if (typeof id === "number") {
      return matcapList[id];
    }

    return null;
  }, [id, matcapList]);
  const fileName = "" + (fileHash || DEFAULT_MATCAP) + getFormatString(format) + ".png";
  const url = MATCAP_ROOT + "/" + format + "/" + fileName;
  const matcapTexture = useTextureLoader(url);
  useEffect(() => {
    fetch(MATCAP_ROOT + "/matcap-list.json").then(response => response.json()).then(data => setMatcapList(data));
  }, [setMatcapList]);
  return [matcapTexture, url];
}

const NORMAL_ROOT = "https://rawcdn.githack.com/emmelleppi/normal-maps/f24c810fc1d86b5b1e5dfea914b668f70b5f2923";
const DEFAULT_NORMAL = "151_norm.JPG";
function useNormalTexture(id = 0, {
  repeat = [1, 1],
  anisotropy = 1,
  offset = [0, 0]
}) {
  const [normalsList, setNormalsList] = useState({});
  const imageName = normalsList[id] || DEFAULT_NORMAL;
  const url = NORMAL_ROOT + "/normals/" + imageName; // @ts-expect-error

  const normalTexture = useTextureLoader(url);
  useEffect(() => {
    fetch(NORMAL_ROOT + "/normals.json").then(response => response.json()).then(data => setNormalsList(data));
  }, [setNormalsList]);
  useEffect(() => {
    if (!normalTexture) return;
    normalTexture.wrapS = normalTexture.wrapT = RepeatWrapping;
    normalTexture.repeat = new Vector2(repeat[0], repeat[1]);
    normalTexture.offset = new Vector2(offset[0], offset[1]);
    normalTexture.anisotropy = anisotropy;
  }, [normalTexture, anisotropy, repeat, offset]);
  return [normalTexture, url];
}

export { useMatcapTexture, useNormalTexture };
